export function checkAccess1(
  menuTree: any[],   // Cây menu
  routerLink: string,      // Đường dẫn cần kiểm tra
  actionCd?: string,       // Mã hành động (có thể có hoặc không)
  tab?: string,            // Tab (có thể có hoặc không)
  subtab?: string          // Subtab (có thể có hoặc không)
): boolean {

  return true
}

// export function CheckAccess(
//   menuTree: any[],   // Cây menu
//   routerLink: string,      // Đường dẫn cần kiểm tra
//   actionCd?: string,       // Mã hành động (có thể có hoặc không)
//   tab?: string,            // Tab (có thể có hoặc không)
//   subtab?: string          // Subtab (có thể có hoặc không)
// ): boolean {
//   // Hàm đệ quy để kiểm tra quyền truy cập
//   function findMenuByRouter(menuList: any[], link: string, action: string | undefined, tab: string | undefined, subtab: string | undefined): boolean {
//       for (const menu of menuList) {
//           // B1: Kiểm tra nếu routerLink truyền vào bằng menu.routerLink
//           if (link === menu.routerLink) {
//               // B2: Nếu link trùng khớp, kiểm tra children
//               if (menu.children && menu.children.length > 0) {
//                   for (const child of menu.children) {
//                       // Kiểm tra nếu có truyền tab
//                       if (tab) {
                      
//                           // Nếu có tab, kiểm tra child.actionCd === tab
//                           if (child.actionCd === tab) {
                          
//                               // Nếu có subtab, kiểm tra trong children của child
//                               if (subtab) {
//                                   for (const child2 of child.children || []) {
//                                       if (child2.actionCd === subtab) {
//                                           return true; // Trả về true nếu tìm thấy subtab
//                                       }
//                                   }
//                               } else {
//                                   // Nếu không có subtab, kiểm tra child2.actionCd === action
//                                   if (action) {
//                                     for (const child2 of child.children || []) {
//                                       if (child2.actionCd === action) {
//                                           return true; // Trả về true nếu tìm thấy action
//                                       }
//                                     }
//                                   }else {
//                                     return true;
//                                   }
                                
//                               }
//                               return false; // Trả về false nếu không tìm thấy subtab hoặc action
//                           }
//                       } else {
//                           // Nếu không có tab, kiểm tra child.actionCd === action
//                           if (child.actionCd === action) {
//                               // Nếu có subtab, kiểm tra trong children của child
//                               if (subtab) {
//                                   for (const child2 of child.children || []) {
//                                       if (child2.actionCd === subtab) {
//                                           return true; // Trả về true nếu tìm thấy subtab
//                                       }
//                                   }
//                               }
//                               return subtab ? false : true; // Trả về true nếu tìm thấy action
//                           }
//                       }
//                   }
//               }
//           }

//           // Kiểm tra children nếu menu không trùng khớp
//           if (menu.children && menu.children.length > 0) {
//               const foundInChildren = findMenuByRouter(menu.children, link, action, tab, subtab);
//               if (foundInChildren) return true; // Nếu tìm thấy trong children, trả về true
//           }
//       }
//       return false; // Không tìm thấy
//   }

//   return findMenuByRouter(menuTree, routerLink, actionCd, tab, subtab);
// }

export function CheckAccess(
  routerLink: string,        // Đường dẫn cần kiểm tra
  actionCd?: string,         // Mã hành động (có thể có hoặc không)
  tab?: string,              // Tab (có thể có hoặc không)
  tabActionCd?: string,      // Mã hành động của tab (có thể có hoặc không)
  subtab?: string,           // Subtab (có thể có hoặc không)
  subtabActionCd?: string    // Mã hành động của subtab (có thể có hoặc không)
): boolean {
  const currentLang: any = localStorage.getItem('menuItems');
  let menuTree = [];
  if (currentLang) {
    menuTree = JSON.parse(currentLang);
  }
  // Hàm đệ quy để kiểm tra quyền truy cập
  function findMenuByRouter(
    menuList: any[],
    link: string,
    action: string | undefined,
    tab: string | undefined,
    tabAction: string | undefined,
    subtab: string | undefined,
    subtabAction: string | undefined
  ): boolean {

    for (const menu of menuList) {
      // B1: Kiểm tra nếu routerLink truyền vào bằng menu.routerLink
      if (link === menu.routerLink) {

        // B2: Nếu link trùng khớp, kiểm tra children
        if (menu.children && menu.children.length > 0) {
          for (const child of menu.children) {
            // Case 1: Chỉ kiểm tra actionCd
            if (action && !tab && !tabActionCd && !subtab && !subtabActionCd) {
         
              if (child.actionCd === action) {
                return true;
              }
            }

            // Case 2: Kiểm tra actionCd và tab
            else if (action && tab && !tabActionCd && !subtab && !subtabActionCd) {

              if (child.actionCd === action) {
                // Kiểm tra xem action có children (tab) không
                if (child.children && child.children.length > 0) {
                  for (const tabItem of child.children) {
                    // console.log(tabItem.actionCd)
                    if (tabItem.actionCd === tab) {
                      return true;
                    }
                  }
                }
              }
            }

            // Case 3: Kiểm tra actionCd, tab và tabActionCd
            else if (action && tab && tabActionCd && !subtab && !subtabActionCd) {
              if (child.actionCd === action) {
                if (child.children && child.children.length > 0) {
                  for (const tabItem of child.children) {
                    if (tabItem.actionCd === tab) {
                      // Kiểm tra xem tab có children (tabAction) không
                      if (tabItem.children && tabItem.children.length > 0) {
                        for (const tabActionItem of tabItem.children) {
                          if (tabActionItem.actionCd === tabActionCd) {
                            return true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            // Case 4: Kiểm tra actionCd, tab và subtab
            else if (action && tab && !tabActionCd && subtab && !subtabActionCd) {
              if (child.actionCd === action) {
                if (child.children && child.children.length > 0) {
                  for (const tabItem of child.children) {
                    if (tabItem.actionCd === tab) {
                      // Kiểm tra xem tab có children (subtab) không
                      if (tabItem.children && tabItem.children.length > 0) {
                        for (const subtabItem of tabItem.children) {
                          if (subtabItem.actionCd === subtab) {
                            return true;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            // Case 4: #thêm Kiểm tra cho subtab
            // check cho subtab có tồn tại không
            else if (action && tab && tabActionCd && subtab && !subtabActionCd) {
              if (child.actionCd === action) {
                if (child.children && child.children.length > 0) {
                  for (const tabItem of child.children) {
                    if (tabItem.actionCd === tab) {

                      // Kiểm tra xem tab có children (subtab) không
                      if (tabItem.children && tabItem.children.length > 0) {
                        for (const actionItemSubTab of tabItem.children) {

                          if (actionItemSubTab.actionCd === tabActionCd) {
                            if (actionItemSubTab.children && actionItemSubTab.children.length > 0) {
                              for (const actionItemTheTab of actionItemSubTab.children) {
                                if(actionItemTheTab.actionCd === subtab) {
                                  return true;
                                }
                              }
                            }
                            
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            // Case 4-1: #thêm Kiểm tra action cho subtab
            // check cho subtab có tồn tại không
            else if (action && tab && tabActionCd && subtab && subtabActionCd) {
          
              if (child.actionCd === action) {
                if (child.children && child.children.length > 0) {
                  for (const tabItem of child.children) {
                    if (tabItem.actionCd === tab) {

                      // Kiểm tra xem tab có children (subtab) không
                      if (tabItem.children && tabItem.children.length > 0) {
                        for (const actionItemSubTab of tabItem.children) {

                          if (actionItemSubTab.actionCd === tabActionCd) {
                            if (actionItemSubTab.children && actionItemSubTab.children.length > 0) {
                              for (const actionItemTheTab of actionItemSubTab.children) {
                                if(actionItemTheTab.actionCd === subtab) {

                                  // danh sách action của sub tab
                                  if (actionItemTheTab.children && actionItemTheTab.children.length > 0) {
                                    for (const actionItemTheSubTab of actionItemTheTab.children) {
                                      if(actionItemTheSubTab.actionCd === subtabActionCd) {
                                        return true;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            // Case 5: Kiểm tra actionCd, tab, subtab và subtabActionCd
            else if (action && tab && !tabActionCd && subtab && subtabActionCd) {
              if (child.actionCd === action) {
                if (child.children && child.children.length > 0) {
                  for (const tabItem of child.children) {
                    if (tabItem.actionCd === tab) {
                      if (tabItem.children && tabItem.children.length > 0) {
                        for (const subtabItem of tabItem.children) {
                          if (subtabItem.actionCd === subtab) {
                            // Kiểm tra xem subtab có children (subtabAction) không
                            if (subtabItem.children && subtabItem.children.length > 0) {
                              for (const subtabActionItem of subtabItem.children) {
                                if (subtabActionItem.actionCd === subtabActionCd) {
                                  return true;
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            // Case 5: Kiểm tra actionCd, tab, subtab và subtabActionCd
            else if (!action && tab && tabActionCd && !subtab && !subtabActionCd) {
              if (child.children) {
                for (const tabItem of child.children) {
                  // chi co tab và action tab
                  if (tabItem.actionCd === tabActionCd && tabItem.children.length <= 0 ) {
                    return true;
                  }else 
                    // nếu có subtab()
                    if(tabItem.children.length){
                      if (tabItem.actionCd === tab && tabItem.children) {
                        for (const subtabActionItem of tabItem.children) {
                          if (subtabActionItem.actionCd === tabActionCd) {
                            return true;
                          }
                        }
                      }
                  }
                }
              }
            }
          }
        }
      }

      // Kiểm tra children nếu menu không trùng khớp
      if (menu.children && menu.children.length > 0) {
        const foundInChildren = findMenuByRouter(
          menu.children,
          link,
          action,
          tab,
          tabActionCd,
          subtab,
          subtabActionCd
        );
        if (foundInChildren) return true;
      }
    }
    return false; // Không tìm thấy
  }

  return findMenuByRouter(menuTree, routerLink, actionCd, tab, tabActionCd, subtab, subtabActionCd);
}


// hàm lấy ra danh sách menu
export function convertMenuData(menuTree) {
  let result = {};

  function traverse(nodes) {
      for (const node of nodes) {
          // Kiểm tra nếu node có classs = "nav-item"
          if (node.classs === "nav-item") {
              const key = convertLabelToKey(node.label); // Chuyển đổi label thành key không dấu
              result[key] = {
                  title: node.label,
                  key: node.routerLink
              };
          }
          // Nếu node có children, đệ quy để duyệt qua các children
          if (node.children && node.children.length > 0) {
              traverse(node.children);
          }
      }
  }

  traverse(menuTree);
  return result;
}

export function  convertLabelToKey(label) {
  // Tạo ra chuỗi thay thế toàn bộ ký tự có dấu thành không dấu
  const accentsMap = [
    "aàáạảãâầấậẩẫăằắặẳẵ",
    "eèéẹẻẽêềếệểễ",
    "iìíịỉĩ",
    "oòóọỏõôồốộổỗơờớợởỡ",
    "uùúụủũưừứựửữ",
    "yỳýỵỷỹ",
    "dđ",
    "AÀÁẠẢÃÂẦẤẬẨẪĂẰẮẶẲẴ",
    "EÈÉẸẺẼÊỀẾỆỂỄ",
    "IÌÍỊỈĨ",
    "OÒÓỌỎÕÔỒỐỘỔỖƠỜỚỢỞỠ",
    "UÙÚỤỦŨƯỪỨỰỬỮ",
    "YỲÝỴỶỸ",
    "DĐ"
  ];

  // Chuyển đổi tất cả các ký tự có dấu thành ký tự không dấu
  let str = label;
  accentsMap.forEach((accentGroup) => {
    const regex = new RegExp('[' + accentGroup.substring(1) + ']', 'g');
    str = str.replace(regex, accentGroup[0]);
  });

  // Chuyển đổi chuỗi thành chữ thường và loại bỏ ký tự đặc biệt
  const key = str
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '') // Loại bỏ ký tự đặc biệt
    .trim() // Loại bỏ khoảng trắng đầu và cuối
    .replace(/\s+/g, '_'); // Thay thế khoảng trắng bằng dấu gạch dưới

  return key;
}

// hàm lấy ra danh sách action tab | subtab | action
export function extractTabActions(menuTree, actionType) {
  let result = {};

  function traverse(nodes) {
      for (const node of nodes) {
          // Kiểm tra điều kiện isAction = true và actionType = 'tab'
          if (node.isAction === true && node.actionType === actionType) {
              const key = convertLabelToKey(node.label); // Chuyển đổi label thành key không dấu
              result[node.actionCd] = {
                  title: node.label,
                  type: node.actionType,
                  key: node.actionCd
              };
          }
          // Nếu node có children, đệ quy để duyệt qua các children
          if (node.children && node.children.length > 0) {
              traverse(node.children);
          }
      }
  }

  traverse(menuTree);
  return result;
}